"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.button_pm = void 0;
var static_values_1 = require("../../../src/core/static-values");
function button_pm(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, hasReturnVal = utils.hasReturnVal, use = utils.use, cySelectSegment = utils.cySelectSegment, cyInput = utils.cyInput, IDs = utils.IDs;
    var _a = static_values_1.staticValues.buttonPM, cpuValue = _a.cpuValue, inputValue = _a.inputValue, labelValue = _a.labelValue;
    var clickBtn2 = function () { return cy.get("#".concat(IDs.buttonIDs.pmID)).click().wait(10).then(cyInput); };
    describe("Button PM - ".concat(labelValue), function () {
        it('Arrow key functions', function () {
            loadPrimaryInput()
                .then(clickBtn2)
                .should('have.value', inputValue)
                .then(hasReturnVal(cpuValue))
                .then(function () {
                return cySelectSegment('hrs12')
                    .then(use.upArrow)
                    .should('have.value', '04:45 PM')
                    .then(use.downArrow)
                    .then(use.downArrow)
                    .should('have.value', '02:45 PM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '02:46 PM')
                    .then(use.downArrow)
                    .then(use.downArrow)
                    .should('have.value', '02:44 PM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '02:44 AM')
                    .then(use.downArrow)
                    .should('have.value', '02:44 PM')
                    .then(use.del)
                    .should('have.value', '02:44 --')
                    .then(use.leftArrow)
                    .then(use.backspace)
                    .should('have.value', '02:-- --')
                    .then(use.leftArrow)
                    .then(use.del)
                    .should('have.value', '--:-- --');
            });
        });
        it('Can press button twice', function () {
            loadPrimaryInput()
                .then(clickBtn2)
                .should('have.value', '03:45 PM')
                .then(hasReturnVal('15:45'))
                .then(function () {
                return cySelectSegment('hrs12')
                    .then(use.upArrow)
                    .should('have.value', '04:45 PM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '04:46 PM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '04:46 AM')
                    .then(clickBtn2)
                    .should('have.value', '03:45 PM');
            });
        });
    });
}
exports.button_pm = button_pm;
